import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { itemLocationApi } from '../api/itemLocationApi'

export function useGetItemLocation(id: string, enabled = true) {
  return useQuery({
    queryKey: ['item-location', id],
    queryFn: () => itemLocationApi.getItemLocation(id),
    enabled: enabled,
    retry: false,
    refetchOnWindowFocus: false,
  })
}

export function useCreateItemLocation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ payload }: { payload: Partial<any> }) => itemLocationApi.createItemLocation(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['item-location'] })
    },
  })
}
